import {ChangeDetectorRef, Component, ElementRef, Renderer2} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {CheckboxFieldConfig} from '../checkbox-field.config';

@Component({
    selector: 'mydocma-form-checkbox-field',
    templateUrl: './checkbox-field.component.html',
    styleUrls: ['./checkbox-field.component.scss'],
    providers: [AsyncPipe]
})
export class CheckboxFieldComponent extends BaseFieldComponent<CheckboxFieldConfig>{

    public readonly staticCssClass = 'mydocma-checkbox-field';

    public collapsed = true;

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }

    public onClick() {
        super.onControlClick();
    }

    public onResize(event) {
        const collapsed = event.contentRect.width <= 500;
        if (collapsed !== this.collapsed) {
            this.collapsed = collapsed;
            this.changeDetectorRef.detectChanges();
        }
    }
}
